export const colorItemTheme = {
  active: {
    borderColor: 'palette.tertiary.90',
    borderRadius: '5px',
    borderWidth: '3px',
    text: 'palette.tertiary.95',
  },
  base: {
    borderColor: 'palette.neutral.50',
    borderRadius: '5px',
    borderWidth: '1px',
    text: 'palette.tertiary.80',
  },
};
